const inbox = {
  state: {},
  mutations: {},
  actions: {},
  getters: {},
};

export default inbox;
